module.exports = __webpack_public_path__ + "img/icon-star.e4b3729d.svg";